import React from 'react';
import { useNavigate } from 'react-router-dom';
import { DashboardIcon } from '../../../../../assets/icons/SidemenuIcons';
import { RavenBadge, RavenNumberFormat } from '@ravenpay/raven-bank-ui';
import { formatNumWithCommaNairaSymbolTwo } from '../../../../../utils/helper/Helper';
import ContainerLayout from '../../../../../layout/dashboard/container';
import DashboardLayout from '../../../../../layout/dashboard/dashboardLayout';
import './styles/index.css';
import UserSignupsMetrics from './UserSignupsMetrics/UserSignupsMetrics';

const BankBox = () => {
	const navigate = useNavigate();

	const dashboard_summary = {
		collectionBalance: 0.0,
		merchantBalance: 0.0,
		totalPendingRequest: 0.0,
		totalBankBoxDisbursed: 0.0,
		totalUsers: 0.0,
		bankSwitchRequests: 5,
	};

	const metricCards = [
		{
			key: 'OutstandingBalance',
			label: 'Outstanding Balance',
			icon: DashboardIcon?.balanceIcon,
			value: dashboard_summary?.collectionBalance,
			onClick: null,
		},
		{
			key: 'RegisteredUsers',
			label: 'Registered Users',
			icon: DashboardIcon?.usersIcon,
			value: dashboard_summary?.totalUsers,
			onClick: null,
			showCountBorder: true,
			countValue: dashboard_summary?.totalUsers,
		},
		{
			key: 'CreditDisbursed',
			label: 'Credit Disbursed',
			icon: DashboardIcon?.bankdisburedIcon,
			value: dashboard_summary?.totalBankBoxDisbursed,
			onClick: null,
			showCountBorder: true,
			countValue: dashboard_summary?.merchantBalance,
		},
		{
			key: 'TotalRepayments',
			label: 'Total Repayments',
			icon: DashboardIcon?.bankreqIcon,
			value: dashboard_summary?.merchantBalance,
			onClick: null,
			showCountBorder: true,
			countValue: dashboard_summary?.merchantBalance,
		},
	];

	return (
		<DashboardLayout>
			<ContainerLayout
				pageTitle="Insights"
				pageSubtitle="Overview of key Tapverse metrics"
				pageMode
				disableBack
				loading={false}
				topRightContent={<div></div>}
				style={{ height: '100%' }}
			>
				<div className="bank-box">
					<div className="bank-box-overview__stats-wrapper">
						{metricCards.map((item, idx) => (
							<div
								key={idx}
								className="bank-box-overview__stats-wrapper--stats grey-bg-two"
								style={{
									cursor:
										typeof item?.onClick === 'function' ? 'pointer' : 'default',
								}}
								onClick={
									typeof item?.onClick === 'function' ? item.onClick : undefined
								}
							>
								<div className="top">
									<figure className="img-box grey-bg-two">{item.icon}</figure>
									{/* {item.badge} */}
								</div>
								<div
									style={{
										marginTop: '2rem',
										marginBottom: '2rem',
										display: 'flex',
										flexDirection: 'column',
										gap: '.5rem',
									}}
								>
									<p>{item.label}</p>
									<h6>
										{(() => {
											const formatted = formatNumWithCommaNairaSymbolTwo(
												item.value,
												{
													hideSymbol: false,
													hideDecimal: false,
												}
											);
											const [whole, decimal] = formatted.split('.');
											const isZero = Number(item.value) === 0;

											return (
												<span>
													{whole}
													{decimal && (
														<span
															className={
																isZero
																	? 'gray-decimal disabled-decimal'
																	: 'gray-decimal'
															}
														>
															.{decimal}
														</span>
													)}
												</span>
											);
										})()}
									</h6>
								</div>

								{item.showCountBorder && (
									<div className="bordered-count-wrapper">
										<div className="count-border" />
										<div className="count-text">
											{item.key === 'RegisteredUsers' ? (
												Number(item.countValue) > 0 ? (
													RavenNumberFormat(item.countValue, {
														hideSymbol: true,
														hideDecimal: true,
													})
												) : (
													<span style={{ fontStyle: 'italic', color: 'gray' }}>
														No active users
													</span>
												)
											) : (
												<span>
													Count:{' '}
													{RavenNumberFormat(item.countValue || 0, {
														hideSymbol: true,
														hideDecimal: true,
													})}
												</span>
											)}
										</div>
									</div>
								)}
							</div>
						))}
					</div>
					<UserSignupsMetrics />
				</div>
			</ContainerLayout>
		</DashboardLayout>
	);
};

export default BankBox;
